import {TextField, Box} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

interface MaterialSearchBarProps {
  searchTerm: string
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

/**
 * Search bar component for filtering materials in the material selection list
 */
export const MaterialSearchBar: React.FC<MaterialSearchBarProps> = ({
  searchTerm,
  onSearchChange
}) => {
  const {t} = useTranslation()

  return (
    <Box sx={{mb: 2}}>
      <TextField
        fullWidth
        variant="outlined"
        placeholder={t('orderIntake.rmc.steps.material.searchPlaceholder', 'Search by mix...')}
        value={searchTerm}
        onChange={onSearchChange}
        data-test-id="rmc-material-search"
      />
    </Box>
  )
}
